import { render } from "./CookiePopup.vue?vue&type=template&id=20ac2a74"
import script from "./CookiePopup.vue?vue&type=script&lang=js"
export * from "./CookiePopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__